import { BuildType } from './ApiService';

export const sessionService = (build: BuildType) => ({
    getSessionIsExpired: build.query<{ message: string } | undefined, void>({
        query: () => 'session/expired',
        providesTags: ['User'],
    }),
    refreshSession: build.mutation<{ ok: boolean }, void>({
        query: () => ({
            url: 'session/refresh',
            method: 'POST',
        }),
        invalidatesTags: ['User'],
    }),
});
